/**
 * Created by rathompson on 8/17/23
 * File: IPRestrictionWrapper.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */

// Libs
import { useContext, ReactNode, VFC } from 'react'

// Utils
import {
  getVarValue,
  getCommonModuleState
} from '../../utils/Sparky'
import { history } from '@sparky/framework'

// Context
import { useIpRestrictionContext } from '../../context/IpRestrictContext'
import GlobalContext from '../../context/GlobalContext'

// Components
import RestrictedAccessScreen from './RestrictedAccessScreen'
import FeatureNotSupportedScreen from './FeatureNotSupportedScreen'

// Constants
import {
  canUseIpAllow,
  FF_IP_ALLOW_LIST
} from '../../utils/FeatureFlags'
import { VIEW_IP_ALLOW_LIST } from '../../constants/GlobalConstants'

const ipAllowEnabled = getVarValue(FF_IP_ALLOW_LIST, false)

const IPRestrictionWrapper: VFC<{ children: ReactNode }> = ({ children }) => {

  const { treeReducer } = useContext(GlobalContext)
  const { isRestricted } = useIpRestrictionContext()
  const { selectedTreeNode } = treeReducer
  const commonModuleState = getCommonModuleState()

  if (
    (commonModuleState?.path === VIEW_IP_ALLOW_LIST || history.location.pathname.includes('/settings/ip')) &&
    !canUseIpAllow(selectedTreeNode)) {
    return <FeatureNotSupportedScreen/>
  }
  if (ipAllowEnabled && isRestricted) {
    return <RestrictedAccessScreen/>
  }
  return (
    <>{children}</>
  )
}

export default IPRestrictionWrapper
